module.exports = __webpack_public_path__ + "img/yzm.4596cc48.svg";